export const LOGOUT_USER = "LOGOUT_USER";

export const SET_USER = "SET_USER";
export const SET_ACTIVE_USER_ID = "SET_ACTIVE_USER_ID";
export const SET_ACTIVE_USER_TYPE = "SET_ACTIVE_USER_TYPE";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";

export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_PAYABLE = "UPDATE_CUSTOMER_PAYABLE";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_QUANTITIES = "UPDATE_PRODUCT_QUANTITIES";

export const GET_PRODUCT_GROUPS = "GET_PRODUCT_GROUPS";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const ADD_COMPANY = "ADD_COMPANY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const DELETE_COMPANY = "DELETE_COMPANY";

export const GET_EMPLOYEES = "GET_EMPLOYEES";
export const ADD_EMPLOYEE = "ADD_EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE ";
export const UPDATE_EMPLOYEE_EXP_SALARY = "UPDATE_EMPLOYEE_EXP_SALARY ";

export const GET_VENDORS = "GET_VENDORS";
export const ADD_VENDOR = "ADD_VENDOR";
export const UPDATE_VENDOR = "UPDATE_VENDOR";
export const UPDATE_VENDOR_PAYABLE = "UPDATE_VENDOR_PAYABLE";

export const GET_SALES_ORDERS = "GET_SALES_ORDERS";
export const ADD_SALES_ORDER = "ADD_SALES_ORDER";
export const REFUND_SALES_ORDER = "REFUND_SALES_ORDER";
export const SHALLOW_DELETE_SALES_ORDER = "SHALLOW_DELETE_SALES_ORDER";

export const GET_PURCHASE_ORDERS = "GET_PURCHASE_ORDERS";
export const ADD_PURCHASE_ORDER = "ADD_PURCHASE_ORDER";
export const UPDATE_PURCHASE_ORDER_STATUS = "UPDATE_PURCHASE_ORDER_STATUS";
export const UPDATE_PURCHASE_ORDER_PRODUCTS = "UPDATE_PURCHASE_ORDER_PRODUCTS";
export const UPDATE_PURCHASE_ORDER_RECEIVED = "UPDATE_PURCHASE_ORDER_RECEIVED";
export const UPDATE_PURCHASE_ORDER_PAYMENT = "UPDATE_PURCHASE_ORDER_PAYMENT";
export const UPDATE_PURCHASE_ORDER_PAY_DATE = "UPDATE_PURCHASE_ORDER_PAY_DATE";
export const SHALLOW_DELETE_PURCHASE_ORDER = "SHALLOW_DELETE_PURCHASE_ORDER";

export const GET_RETURN_ORDERS = "GET_RETURN_ORDERS";
export const ADD_RETURN_ORDER = "ADD_RETURN_ORDER";

export const GET_EXPENSES = "GET_EXPENSES";
export const ADD_EXPENSE = "ADD_EXPENSE";
//export const DELETE_EXPENSE = "DELETE_EXPENSE";

export const GET_EXPENSE_TYPES = "GET_EXPENSE_TYPES";
export const ADD_EXPENSE_TYPE = "ADD_EXPENSE_TYPE";
export const DELETE_EXPENSE_TYPE = "DELETE_EXPENSE_TYPE ";

export const SET_SO_DISPLAY_ID = "SET_SO_DISPLAY_ID";
export const SET_SO_CUSTOMER_ID = "SET_SO_CUSTOMER_ID";
export const SET_SO_PRODUCTS = "SET_SO_PRODUCTS";
export const SET_SO_PAYMENT_INFO = "SET_SO_PAYMENT_INFO";
export const SET_NEW_SO_INFO = "SET_NEW_SO_INFO";
export const CLEAR_NEW_SO = "CLEAR_NEW_SO";

export const SET_PO_DISPLAY_ID = "SET_PO_DISPLAY_ID";
export const SET_PO_VENDOR_ID = "SET_PO_VENDOR_ID";
export const SET_PO_PRODUCTS = "SET_PO_PRODUCTS";
export const SET_PO_DATE = "SET_PO_DATE";
export const SET_PO_STATUS = "SET_PO_STATUS";
export const SET_PO_PAYMENTS = "SET_PO_PAYMENTS";
export const SET_PO_RECEIVED = "SET_PO_RECEIVED";
export const SET_NEW_PO_INFO = "SET_NEW_PO_INFO";
export const CLEAR_NEW_PO = "CLEAR_NEW_PO";

export const GET_ID_GEN = "GET_ID_GEN";
export const INCREMENT_ID_GEN = "INCREMENT_ID_GEN";

export const INCREMENT_FAILED_LOGIN = "INCREMENT_FAILED_LOGIN";
export const RESET_FAILED_LOGIN = "RESET_FAILED_LOGIN";